import React from 'react'

type TypingAnimationToggleProps = {
  enabled: boolean
  preference: 'on' | 'off'
  blocked?: boolean
  onToggle: (next: boolean) => void
  title?: string
  description?: string
  className?: string
}

const TypingAnimationToggle = ({
  enabled,
  preference,
  blocked = false,
  onToggle,
  title = 'Typing animation',
  description = 'Smoothly reveals assistant replies.',
  className = '',
}: TypingAnimationToggleProps) => {
  const hint = blocked ? 'Disabled by your reduced-motion setting.' : description
  const buttonLabel = blocked ? 'Disabled' : enabled ? 'On' : 'Off'

  return (
    <div className={`chat-typing-toggle ${blocked ? 'is-blocked' : ''} ${className}`.trim()}>
      <div className="chat-typing-toggle-copy">
        <span className="chat-typing-toggle-label">{title}</span>
        <span className="chat-typing-toggle-hint">{hint}</span>
      </div>
      <button
        type="button"
        className={`chat-typing-toggle-button${enabled ? ' on' : ''}`}
        onClick={() => onToggle(!enabled)}
        disabled={blocked}
        aria-pressed={enabled}
        aria-label={`${title}: ${preference === 'off' ? 'Off' : 'On'}`}
      >
        {buttonLabel}
      </button>
    </div>
  )
}

export default TypingAnimationToggle
